import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { LANGUAGE_CODES } from 'Douleutaras/constants/system';
import { CategoryMenu } from 'Douleutaras/types/index';

export const fetchCategoriesMenu = createAsyncThunk(
  'categoriesMenu/fetchCategoriesMenu',
  async (language: string, api) => {
    const endpoint = `api/public/category_megamenu/?alias=bsdir_page_menu${language === LANGUAGE_CODES.EN ? '_en' : ''}`;

    const additionalRequestOptions = {
      additionalHeaders: undefined
    };

    // If language is defined, send a languagecode header which saves values to different language
    if (language) {
      additionalRequestOptions.additionalHeaders = {
        languagecode: language
      };
    }

    const response = await makeRequest(endpoint,
      {
        method: 'GET',
        ...additionalRequestOptions
      }
    )(api);

    return response.data;
  }
);

export const categoriesMenuSlice = createSlice({
  name: 'categoriesMenu',
  initialState: {
    data: [] as Array<CategoryMenu>,
    loading: false,
    error: undefined
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCategoriesMenu.pending, state => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchCategoriesMenu.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCategoriesMenu.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});
